import React, { ReactNode } from 'react';
import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

interface PageBackgroundProps {
    children: ReactNode;
    enabled?: boolean;
    opacity?: number;
    backgroundPosition?: string;
    sx?: SxProps<Theme>;
}

const PageBackground: React.FC<PageBackgroundProps> = ({
    children,
    enabled = true,
    opacity = 0.2,
    backgroundPosition = 'center',
    sx
}) => {
    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                minHeight: '100%',
                ...sx
            }}
        >
            {enabled && (
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        zIndex: 0,
                        pointerEvents: 'none',
                        backgroundImage: 'url(/images/BGMain.webp)',
                        backgroundSize: '100% auto',
                        backgroundRepeat: 'repeat-y',
                        backgroundPosition: backgroundPosition,
                        opacity: opacity
                    }}
                />
            )}
            <Box sx={{ position: 'relative', zIndex: 1 }}>
                {children}
            </Box>
        </Box>
    );
};

export default PageBackground;
